import { render, staticRenderFns } from "./TrademarkProvisionalCaseInstruction.vue?vue&type=template&id=bad0e914&"
import script from "./TrademarkProvisionalCaseInstruction.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalCaseInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports